<div>
    <div style="margin-bottom: 10px; height: 32px; display: flex; align-items: center;">
        <mat-icon>error</mat-icon>
        <div style="text-align:center; line-height: 32px; vertical-align: middle !important; margin-left: 10px; height: 100%; font-weight: bold; font-size: 12pt;">Please fix the following validation errors</div>
    </div>
    <mat-list>
        <mat-list-item style="margin-bottom: 2px;" *ngFor="let error of errorMessages">{{error}}</mat-list-item>
    </mat-list>
</div>
